export default __webpack_public_path__ + "static/media/links-pfreport-j.f0449c6f.png";